import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    formValues_a: {
      title: '【Q1】J-REIT個別銘柄に投資を始めた理由は？（複数回答可）',
      saveValue: [],
      nameProperty: 'entry.1205995101',
      saveValueOther: '',
      namePropertyOther: 'entry.1312920455',
      value: ['REITの仕組みが良い', 'REITが運用する不動産が良い', '運用実績（トラックレコード）がある', 'REIT市場に成長性がある', '分配金利回りが高い',
        '分配金利回りが安定', '決算期が分散', '投資口価格（株価）の上昇', '投資口価格（株価）の安定', 'ミドルリスク・ミドルリターン', '少額で不動産投資ができる',
        '換金戦・流動性が高い', '透明性が高い', '業績予想の確実性が高い', 'スポンサーの信用力が高い', 'ESGの取組みが進んでいる', '分散投資のひとつとして',
        'インフレヘッジ', 'メディア、証券会社、知人等、他者からの勧め', '他に投資先がない', 'その他:']
    },
    formValues_b: {
      title: '【Q2】銘柄選択の基準、重要視することは？（複数回答可）',
      saveValue: [],
      nameProperty: 'entry.386818371',
      saveValueOther: '',
      namePropertyOther: 'entry.1577215578',
      value: ['投資口価格（株価）', '分配金利回り', 'NAV倍率（PBR）', '時価総額',
        '運用実績（トラックレコード）の長さ', '分配金の推移', 'スポンサー', '決算期', '投資対象の用途',
        '投資対象の地域', 'ポートフォリオ（組入資産）', 'NOI利回り', '含み損益率', '内部留保残高', '負債比率', '格付', '投資主優待', 'ESG評価', 'その他:']
    },
    formValues_c: {
      title: '【Q3】現在のJ-REIT投資額は？',
      requiredMark: '*必須',
      saveValue: '',
      nameProperty: 'entry.1791466893',
      value: ['1億円以上', '5,000万円～1億円', '2,500万円～5,000万円', '1,000万円～2,500万円', '500万円～1,000万円',
        '100万円～500万円', '50万円～100万円', '50万円未満', '0円']
    },
    formValues_d: {
      title: '【Q4】現在のJ-REIT投資額は金融資産全体の何％？',
      requiredMark: '*必須',
      saveValue: '',
      nameProperty: 'entry.1334752422',
      value: ['80％以上', '60～80％', '40～60％', '20～40％', '20％未満']
    },
    formValues_e: {
      title: '【Q5】J-REIT投資期間はどのくらい？（予定も含め）',
      requiredMark: '*必須',
      saveValue: '',
      nameProperty: 'entry.1298925208',
      value: ['5年以上', '3～5年', '1～3年', '1年以内、もしくは元本価格や分配金利回りによって随時売却']
    },
    formValues_f: {
      title: '【Q6】J-REITを売却しよう（売却した）とする要因は？（複数回答可）',
      saveValue: [],
      saveValueOther: '',
      namePropertyOther: 'entry.988578412',
      nameProperty: 'entry.1031903435',
      value: ['投資口価格の上昇・売却益の確定', '純資産価格との乖離が大きい（NAV倍率の上昇）', '投資口価格の下落・損切り', '分配金利回りの低下', '分配金額の減少',
        '運用方針・運用体制に疑問', 'REITの仕組みに懸念', 'REIT市況の懸念', '不動産市況の懸念', '金利上昇の懸念',
        '他のREIT銘柄へ振り替え', 'REIT組入れの投資信託・ETFへ振り替え', '株式等他の金融商品へ振り替え', '個人的な事情', '売却予定はない', 'その他:']
    },
    formValues_g: {
      title: '【Q7】今後J-REIT投資額を金融資産全体の何％にしたい？',
      requiredMark: '*必須',
      saveValue: '',
      nameProperty: 'entry.554972598',
      value: ['80％以上', '60～80％', '40～60％', '20～40％', '20％未満']
    },
    formValues_h: {
      title: '【Q8】J-REITに投資（追加投資）するために何を望みますか？（複数回答可）',
      saveValue: [],
      nameProperty: 'entry.1022049765',
      saveValueOther: '',
      namePropertyOther: 'entry.721595677',
      value: ['運用実績（トラックレコード）の積み上げ', '投資口価格（株価）の上昇', '投資口価格（株価）の安定', '分配金利回りの上昇（投資口価格の下落）', '1口当たり分配金の成長',
        '1口当たり分配金の安定', '時価総額の成長', '資産規模の拡大（外部成長）', '保有不動産の売却（含み益の実益化）', 'ポートフォリオの分散', '財務の安定性', '情報開示', 'スポンサーの信用力', '投資口分割', '自己投資口の取得', '再編（合併・スポンサー交代）',
        '海外不動産投資', 'ESGの取組み強化', 'IR活動の強化（WEB・個別説明・説明会開催等）', '特になし', 'その他:']
    },
    formValues_i: {
      title: '【Q9】今後投資したい用途は？（複数回答可）',
      saveValue: [],
      nameProperty: 'entry.150600168',
      saveValueOther: '',
      namePropertyOther: 'entry.569929627',
      value: ['オフィスビル', '住宅', '都市型商業施設', '郊外型商業施設', 'ホテル',
        '物流施設', 'ヘルスケア施設', '土地（底地権）', 'インフラ施設', '工場・研究施設', 'データセンター', '特になし・分からない', 'その他:']
    },
    formValues_10: {
      title: '【Q10】J-REITについてご意見・ご質問ありましたらご自由にお書き下さい',
      saveValue: '',
      nameProperty: 'entry.678134866'
    },
    formValues_11: {
      title: '【Q11】当サイト「JAPAN-REIT.COM」についてご意見・ご質問ありましたらご自由にお書き下さい',
      saveValue: '',
      nameProperty: 'entry.303951750'
    },
    formValues_l: {
      title: '性別',
      requiredMark: '*必須',
      saveValue: '',
      nameProperty: 'entry.686894043',
      saveValueOther: '',
      namePropertyOther: 'entry.1807346048',
      value: ['男性', '女性', '回答しない', 'その他:']
    },
    formValues_m: {
      title: '年齢',
      requiredMark: '*必須',
      saveValue: '',
      nameProperty: 'entry.672512700',
      value: ['20歳未満', '20～29歳', '30～39歳', '40～49歳', '50～59歳', '60～69歳', '70～79歳', '80歳以上', '回答しない']
    },
    formValues_host: {
      saveValue: '',
      nameProperty: 'entry.321381895'
    }
  },
  mutations: {
    setFormValues_a (state, payload) {
      state.formValues_a = payload.formValues_a
    },
    setFormValues_b (state, payload) {
      state.formValues_b = payload.formValues_b
    },
    setFormValues_c (state, payload) {
      state.formValues_c = payload.formValues_c
    },
    setFormValues_d (state, payload) {
      state.formValues_d = payload.formValues_d
    },
    setFormValues_e (state, payload) {
      state.formValues_e = payload.formValues_e
    },
    setFormValues_f (state, payload) {
      state.formValues_f = payload.formValues_f
    },
    setFormValues_g (state, payload) {
      state.formValues_g = payload.formValues_g
    },
    setFormValues_h (state, payload) {
      state.formValues_h = payload.formValues_h
    },
    setFormValues_i (state, payload) {
      state.formValues_i = payload.formValues_i
    },
    setFormValues_10 (state, payload) {
      state.formValues_10 = payload.formValues_10
    },
    setFormValues_11 (state, payload) {
      state.formValues_11 = payload.formValues_11
    },
    setFormValues_l (state, payload) {
      state.formValues_l = payload.formValues_l
    },
    setFormValues_m (state, payload) {
      state.formValues_m = payload.formValues_m
    },
    setFormValues_host (state, payload) {
      state.formValues_host = payload.formValues_host
    }
  },
  actions: {},
  modules: {}
})
